import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { InputTextModule } from 'primeng/inputtext';
import { GalleriaModule } from 'primeng/galleria';
import { ToolbarModule } from 'primeng/toolbar';
import { ToastModule } from 'primeng/toast';
import { InputMaskModule } from 'primeng/inputmask';
import { RippleModule } from 'primeng/ripple';
import { MessageService } from 'primeng/api';
import { ChipModule } from 'primeng/chip';
import { CardModule } from 'primeng/card';
import { DataViewModule } from 'primeng/dataview';
import { RatingModule } from 'primeng/rating';
import { DropdownModule } from 'primeng/dropdown';
import { AvatarModule } from 'primeng/avatar';
import { MenuModule } from 'primeng/menu';
import { CalendarModule } from 'primeng/calendar';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DialogModule } from 'primeng/dialog';
import { MessagesModule } from 'primeng/messages';
import { MessageModule } from 'primeng/message';
import { CarouselModule } from 'primeng/carousel';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { PasswordModule } from 'primeng/password';
import { DividerModule } from 'primeng/divider';
import { ChipsModule } from 'primeng/chips';
import { FileUploadModule } from 'primeng/fileupload';
import {
  HttpClient,
  HttpClientModule,
  HTTP_INTERCEPTORS,
} from '@angular/common/http';
import { SidebarModule } from 'primeng/sidebar';
import { SkeletonModule } from 'primeng/skeleton';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { PaginatorModule } from 'primeng/paginator';
import { ImageModule } from 'primeng/image';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { SelectButtonModule } from 'primeng/selectbutton';
import { CreditsFormatterModule } from './credits-formatter.module';
import { TableModule } from 'primeng/table';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { MenuIconsComponent } from 'src/app/layouts/main-layout/components/menu-item/menu-icons/menu-icons.component';
import { LazyImgDirective } from 'src/app/directives/lazy-img.directive';
import { LazyLoadCategories } from 'src/app/directives/lazy-load-games.directive';
// import { InputGroupModule } from 'primeng/inputgroup';
// import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}
@NgModule({
  declarations: [
    MenuIconsComponent,
    LazyImgDirective,
    LazyLoadCategories,
  ],
  imports: [
    CommonModule,
    ButtonModule,
    CheckboxModule,
    InputTextModule,
    GalleriaModule,
    ToolbarModule,
    ToastModule,
    RippleModule,
    ChipModule,
    CardModule,
    DataViewModule,
    RatingModule,
    DropdownModule,
    InputMaskModule,
    AvatarModule,
    MenuModule,
    CalendarModule,
    FormsModule,
    ReactiveFormsModule,
    DialogModule,
    MessagesModule,
    MessageModule,
    CarouselModule,
    ScrollPanelModule,
    PasswordModule,
    DividerModule,
    ChipsModule,
    FileUploadModule,
    HttpClientModule,
    SidebarModule,
    SkeletonModule,
    ConfirmDialogModule,
    PaginatorModule,
    ImageModule,
    ProgressSpinnerModule,
    SelectButtonModule,
    TranslateModule.forRoot({
      defaultLanguage: 'es-MX',
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    TableModule,
    // InputGroupModule,
    // InputGroupAddonModule,
  ],
  exports: [
    ButtonModule,
    CheckboxModule,
    InputTextModule,
    GalleriaModule,
    ToolbarModule,
    ToastModule,
    RippleModule,
    ChipModule,
    CardModule,
    ToastModule,
    InputMaskModule,
    DataViewModule,
    RatingModule,
    DropdownModule,
    AvatarModule,
    MenuModule,
    CalendarModule,
    FormsModule,
    ReactiveFormsModule,
    DialogModule,
    MessagesModule,
    MessageModule,
    CarouselModule,
    ScrollPanelModule,
    PasswordModule,
    DividerModule,
    ChipsModule,
    FileUploadModule,
    HttpClientModule,
    SidebarModule,
    SkeletonModule,
    ConfirmDialogModule,
    PaginatorModule,
    ImageModule,
    ProgressSpinnerModule,
    SelectButtonModule,
    CreditsFormatterModule,
    TableModule,
    MenuIconsComponent,
    // InputGroupModule,
    // InputGroupAddonModule,
    LazyImgDirective,
    LazyLoadCategories
  ],
  providers: [MessageService],
})
export class SharedModule {}
